//import getValueFromDictArray from "./utils"
import {DEFAULT_STATE_VALUE,DEFAULT_STONE,ALL_STONES,IMAGE_URL,IMAGE_URL_PROD} from '../constants';
//import {metalQuality} from './utils';

export  default function imageLogic (state) {
 //console.log('start image logic',state) 
 if (state.hasOwnProperty('list_sku') === false){
    return ''
  }
 //let base_url=state.view_image_base;
 
 let base_url=IMAGE_URL
 let base_url2=IMAGE_URL
 
 //'//images4.thepersonalizedbest.com/engrave.jpg/'
 if (window.currentEnv ==='www'){
     base_url =IMAGE_URL_PROD
     base_url2 =IMAGE_URL_PROD
 }
 
 //if (window.currentEnv === 'test')
 if (state.test === 'yes')
  base_url = base_url.replace('images.','us.')
 // console.log('base_url',base_url,state,window.currentEnv)
   
    // add sku
 if (state['style']==='7862'){
      base_url+='?sku=7862';
     // console.log('control3',state['style'])
        
     }  
else    if (state['style']==='1001'){
      base_url+='?sku=1001';
     // console.log('control3',state['style'])
        
     }
 else     
 if (state.hasOwnProperty('show_image_as') && state['show_image_as'] === 'style'){
  base_url+='?sku=' + state['style'];
 // console.log('control3',state['style'])
    
 }
 else { 

    base_url+='?sku=' + state['sku'];
    //console.log('TRY-CONTROL for base url sku',base_url,state)
   
 }

  
//console.log('state.m',state.m)

  // add metal
  let metalValue= ''
  switch (state['m']) {
      
    case 'no':
        metalValue='no'
      break
    case 'g10y':
    case 'g14y':
    case 'spy':
        metalValue='gold'
      break
    case 'spr':
    case 'g10r':
    case 'g14r':
      metalValue='rose'
      break
    default:
      metalValue='silver'
  } 
// stones

for (let j in state.options_all) {
  if (ALL_STONES.indexOf(state.options_all[j]) !== -1) {
   if (state['options_'+state.options_all[j]].show || state.options_all.indexOf('sc') !== -1) { 
    let stoneValue = DEFAULT_STONE
    if (state.hasOwnProperty(state.options_all[j]) && state[state.options_all[j]] !== DEFAULT_STATE_VALUE)
      stoneValue = state[state.options_all[j]]
    base_url+='&' + state['options_'+state.options_all[j]].subtype + '=' + stoneValue;
   }
  }

}
//console.log('initials',base_url,state)
  // add engraving
  if (state.options_all !== undefined && state.options_all.indexOf('e') !== -1) {
   
    let not_typed = true
    if (state.options_e.show === true)
    for (let i in state.options_e.options) {
      if (state.options_e.options[i].show && state[state.options_e.options[i].attr] !== '' ) {
        not_typed = false
      }
      
    }
    

    let textValue;
   // if (state.options_e.show === true) {
   // cuff link  make double engraving
   let cuff_link_list=['6779','6781']
    for (let i in state.options_e.options) {
      /* if (not_typed)
        textValue =state.options_e.options[i].init_text;
      else
         */textValue = state[state.options_e.options[i].attr]
      if (textValue !== '') {
        base_url+='&text' + i + '=' + encodeURIComponent(textValue);
        if (cuff_link_list.indexOf(state['style']) !== -1) 
          base_url+='&text1=' + encodeURIComponent(textValue);
      }  
      }
    
    if (state.hasOwnProperty('f')) {
      if ([11,12,13].includes(parseInt(state['f'],10))) {
      base_url+='&fontid=' +(parseInt(state['f'],10)).toString();
      }
      else {
      base_url+='&fontid=' +(parseInt(state['f'],10)%2).toString();
      }
    }
  //}
  }
  let initial1_list=['5262','4714','4688','4679','4740','4766','9172','9388','9529','6932','5331','5670','5708']
  let initialLetter_list=['7444']
  let initial2_list=['8702','5312','1001','2101','2202','2206','2102','4843','4845','4846','4843','4845' ,'4846','4794','4796','4924','4925','4926','4927','5030','5112','7651','5382','5696','5758']
  let initial4_list=['4919' ]
  let initial0_list=['7857','7853','7854','7858','7859','7855','7856','5311','5313','5314','5424']
  let initial00_list=['7862']
  
  //let initial3_list=['2201','2205','4792']
    
  var e1,e2;
  if (initial1_list.indexOf(state['style']) !== -1 ||initial2_list.indexOf(state['style']) !== -1||initial4_list.indexOf(state['style']) !== -1) 
    {
     e1=  state.e1
     if (e1==='-1') e1=''
        base_url+='&text0=' +encodeURIComponent(e1);
    }
    if (initialLetter_list.indexOf(state['style']) !== -1 ) 
    {
       e1=  state.i
       base_url+='&i=' +e1;
    }
    if (initial2_list.indexOf(state['style']) !== -1||initial4_list.indexOf(state['style']) !== -1) 
    {
       e2=  state.e2
      if (e2==='-1') e2=''
         base_url+='&text1=' +e2;
     }
     if (initial0_list.indexOf(state['style']) !== -1) 
     {
       e2=  state.i
          base_url+='&text0=' +e2;
      }
      if (initial00_list.indexOf(state['style']) !== -1) 
      {
           base_url+='&text0=' +state.e1+'&text1=' +state.e2;
       }
       if (initial4_list.indexOf(state['style']) !== -1) 
    {
      var e3=  state.e3
      if (e3==='-1') e3=''
         base_url+='&text2=' +e3;
      var e4=  state.e4
         if (e4==='-1') e4=''
            base_url+='&text3=' +e4;
        }

     //  console.log('start image logic22',base_url,state) 
    
     if (['9000','9082'].indexOf(state['style']) !== -1 ) //--------------------charms
    {
      if ( state.chain ==='-1' && state.style==='9000')
      return "https://static.thepersonalizedbest.com/pers4/init-charm.jpg?f"
         
      
      if (state.locket ==='-1' && state.style==='9082')
         return "https://static.thepersonalizedbest.com/pers4/init-locket.jpg?f"
      
      base_url=base_url2 +'?sku=' + state['style'] + '&chain=' + state['chain'] ;;
      if (state.view ==='2' && state.style==='9000')
         return base_url2 +'?sku=' + state['style']
      if (state['locket'] === '9083')
        base_url=base_url2 +'?sku=' + state['locket'] ;
      
       var ii=0
       var charm_sku;
       var list5=[]
       if  (state['clist'] !=='-1' ){
        list5=state['clist'].split('_')
       }
       var newch=''
       if  (state['acat'] !=='-1' && state['acharm'] !=='-1')
       {
       if (state['acat']==='1'){
        newch += state['acat'] +'|'+ state['acharm'] +'|'+state['am'] 
        newch += '|'+state['ai']
        list5.push(newch)
      }
       else  if (state['s']==='9000' && state['acat']==='2' && state['e1'] !=='' && state['e1'] !==undefined){
        newch += state['acat'] +'|'+ state['acharm'] +'|'+state['am'] 
        newch += '|'+state['e1'] 
        list5.push(newch)
       }
       else  if (state['s']==='9000' && state['acat']==='11'){

        newch += state['acat'] +'|'+ state['acharm'] +'|'+state['am'] +'|'+state['f'] 
        newch += '|'
        if ( state['e1'] !=='' && state['e1'] !==undefined)
          newch += state['e1'] 
        newch += '|'
        if ( state['e2'] !=='' && state['e2'] !==undefined)
        newch += state['e2'] 
       //console.log('3',newch,state['e2'])
        list5.push(newch)
       }
       else  if (state['s']!=='9000' && state['acat']==='2'){
        newch += state['acat'] +'|'+ state['acharm'] +'|'+state['am'] 
        list5.push(newch)
       }
       else if (['3','4','5','12'].includes(state.acat))
       {
        newch += state['acat'] +'|'+ state['acharm'] +'|'+state['am'] 
        list5.push(newch)
      }  
       }
    //   console.log('list5',list5)


       var ii0=0
       var iii
       for (ii of list5){
         ii0+=1
         iii= ii.split('|')
       //console.log('imageLogic0',ii,iii)

       if  (iii[0] !=='-1' && iii[1] !=='-1')
       {
     //   console.log('imageLogic0',ii,base_url,state)

      if (iii[0] !=='-1'){
        var color='W'
        if (iii[2].indexOf('y') !== -1)
          color='Y'
        if (iii[2].indexOf('r') !== -1)
          color='R'
        charm_sku =iii[1]
        if (iii[0] ==='1' && charm_sku !== '-1'){
             
           charm_sku = parseInt(charm_sku,10) + iii[3].toUpperCase().charCodeAt(0) -65
         //  console.log('imageLogic09',ii,charm_sku,state['i__'+ii],state['i__'+ii].toUpperCase().charCodeAt(0))
        }
        if (charm_sku.toString() !=='' && charm_sku.toString() !=='NaN'){
         if (charm_sku.toString() ==='4916' || charm_sku.toString() ==='4917'){
           var ee=iii[3]  
           base_url+='&text'+ (ii0-1).toString()+ '='+charm_sku.toString()+'|'+ee+'|'+color
           }
         else  if (charm_sku.toString() ==='6394' || charm_sku.toString() ==='6395'         ){
            base_url+='&text'+ (ii0-1).toString()+ '='+charm_sku.toString()+'|'+encodeURIComponent(iii[4])+'|'+encodeURIComponent(iii[5])+'|'+iii[3]+'|'+color
            //base_url+='&text'+ (ii0-1).toString()+ '='+charm_sku.toString()+'|'+iii[4]+'|'+iii[5]+'|'+iii[3]+'|'+color
            }
         else  if ( charm_sku.toString() ==='6396'){
              base_url+='&text'+ (ii0-1).toString()+ '='+charm_sku.toString()+'|'+encodeURIComponent(iii[4])+'|'+iii[3]+'|'+color
              //base_url+='&text'+ (ii0-1).toString()+ '='+charm_sku.toString()+'|'+iii[4]+'|'+iii[3]+'|'+color
              }
         else  if ( charm_sku.toString() ==='6997'){
              base_url+='&text'+ (ii0-1).toString()+ '='+charm_sku.toString()+'|'+encodeURIComponent(iii[4])+'|'+iii[3]+'|'+color
              //base_url+='&text'+ (ii0-1).toString()+ '='+charm_sku.toString()+'|'+iii[4]+'|'+iii[3]+'|'+color
              }
             else
           base_url+='&text'+ (ii0-1).toString()+ '='+charm_sku.toString()+'|'+color
          }  
      }
      }
      }
     }
     
     if (state['chain'] ==='no')
     base_url+='&material=no'
        else
     base_url+='&material='+metalValue;
  //console.log('imageLogic',base_url,state)


  //labels Front and Back

  base_url += '&site='+window.currentSite 

  return base_url
   
  }
  



// WEBPACK FOOTER //
// ./src/reducers/imageLogic.js